import React, { useState } from "react";
import { WinImage } from "../../assets";
import styles from './index.module.css';
import { useMotionValueEvent, useScroll } from "framer-motion";
import { EngineCard, FeatureCards, Sparkels } from "../../Components";

const Features = (props) => {

    const [scrollPos, setScrollPos] = useState(0);
    const { scrollY } = useScroll();

    useMotionValueEvent(scrollY, "change", (latest) => {
        latest < 400 && setScrollPos(latest);
      });
    
    return (
      <div className="bg-[#020714]">
      <div className={`${styles["hero-spacer"]}`} />
      <div
        key={scrollPos}
        style={{ bottom: scrollPos * 2 + props.height * 0.05 }}
        className={`${styles["content-section"]}`}
      >
        <p className={`${styles.subt}`}>
          Introducing Your New Chess Home
        </p>
        <h3 className={`${styles.title}`}>
          Grow Your Skills With
          <br />
          The Ultimate Analysis Platform
        </h3>
        <Sparkels />
        <p className={`${styles.subp}`}>
          Let us take your chess to the next level with deep cloud analysis at prices never seen before. 
          Enjoy our rich master's games database and analysis database with millios of stored analysis to save you time.
          We guarantee the best analysis experience available ! 
        </p>
        <div className={` flex items-center float-right ${props.width < 700 ? 'scale-[0.8] relative left-[10%]' : props.width < 1520 ? 'justify-center w-full' : 'justify-end w-[40%] min-w-[70%]'}`}>
        <img className={`relative pl-[20px] min-w-[60vh] h-[70vh] bottom-[${props.width < 1300 ? '15vh' : '20vh'}] right-[2vw]`} src={WinImage} />
        </div>
        <FeatureCards />
      </div>
      
        </div>
    )
}

export default Features;